module.exports = __webpack_public_path__ + "img/edit.7a14112e.svg";